export const VIEW_COUNTRY = 'country';
export const VIEW_TRANSLATION = 'translation';
export const VIEW_TERM_AND_CONDITION = 'term_and_condition';
export const VIEW_PRIVACY_POLICY = 'privacy_policy';
export const VIEW_SYSTEM_LIMIT = 'system_limit';
export const VIEW_CLINIC = 'clinic';
export const VIEW_PROFESSION = 'profession';
export const VIEW_LANGUAGE = 'language';
export const VIEW_STATIC_PAGE = 'static_page';
export const VIEW_GUIDANCE_PAGE = 'guidance_page';
export const VIEW_PHC_WORKER_GUIDANCE = 'phc_worker_guidance';
export const VIEW_DISEASE = 'disease';
export const VIEW_ORGANIZATION = 'organization';
export const VIEW_ASSISTIVE_TECHNOLOGY = 'assistive_technology';
export const VIEW_COLOR_SCHEME = 'color_scheme';
export const VIEW_SURVEY = 'survey';
export const VIEW_SCREENING_QUESTIONNAIRE = 'screening_questionnaire';
export const VIEW_MFA_POLICY = 'mfa_policy';
export const VIEW_HEALTH_CONDITION = 'health_condition';
export const VIEW_REGION = 'region';
export const VIEW_PROVINCE = 'province';
export const VIEW_PHC_SERVICE = 'phc_service';
export const VIEW_API_CLIENT = 'api_client';
export const VIEW_EMAIL_TEMPLATE = 'email_template';

export const SETTINGS = [
  VIEW_COUNTRY,
  VIEW_TRANSLATION,
  VIEW_TERM_AND_CONDITION,
  VIEW_PRIVACY_POLICY,
  VIEW_SYSTEM_LIMIT,
  VIEW_CLINIC,
  VIEW_PROFESSION,
  VIEW_LANGUAGE,
  VIEW_STATIC_PAGE,
  VIEW_GUIDANCE_PAGE,
  VIEW_PHC_WORKER_GUIDANCE,
  VIEW_DISEASE,
  VIEW_ORGANIZATION,
  VIEW_ASSISTIVE_TECHNOLOGY,
  VIEW_COLOR_SCHEME,
  VIEW_SURVEY,
  VIEW_SCREENING_QUESTIONNAIRE,
  VIEW_MFA_POLICY,
  VIEW_HEALTH_CONDITION,
  VIEW_REGION,
  VIEW_PROVINCE,
  VIEW_PHC_SERVICE,
  VIEW_API_CLIENT,
  VIEW_EMAIL_TEMPLATE,
];

export const TEXT_MAX_LENGTH = {
  GSM_7: 160,
  NON_GSM: 70
};

export const TRANSLATION_KEYS = {
  SMS_REMINDER_ALERT: 'sms.reminder.alert'
};

export const singleIpRegex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
